import { CacheService } from "./cache-service";
import StoreService from "./store-service";

const localStorageCache = new StoreService(localStorage);
const sessionStorageCache = new StoreService(sessionStorage);
Object.freeze(localStorageCache);

const cacheService = new CacheService(sessionStorageCache);

export {
  cacheService,
  localStorageCache,
  sessionStorageCache,
};
